export const categories = [
  {
    id: 1,
    name: "Tecnología",
    subcategories: [
      { id: 101, name: "Computadoras" },
      { id: 102, name: "Smartphones" },
      { id: 103, name: "Tablets" },
      { id: 104, name: "Accesorios" }
    ]
  },
  {
    id: 2,
    name: "Deportes",
    subcategories: [
      { id: 201, name: "Fútbol" },
      { id: 202, name: "Baloncesto" },
      { id: 203, name: "Tenis" },
      { id: 204, name: "Natación" }
    ]
  },
  {
    id: 3,
    name: "Otros",
    subcategories: [
      { id: 301, name: "Electrodomésticos" },
      { id: 302, name: "Muebles" },
      { id: 303, name: "Decoración" }
    ]
  }
];